import { Grid, styled, Theme } from '@mui/material';

import WsColors from '../../WsColors';

interface IEmailFooterProps {
  theme: Theme;
  size?: string;
}

const EmailFooter = styled(Grid)(({ theme, size = 'medium' }: IEmailFooterProps) => ({
  position: 'fixed',
  backgroundColor: WsColors.TertiaryShades50,
  padding: theme.spacing(1),
  bottom: 1,
  width: size == 'medium' ? '50vw' : '75vw',
  overflowX: 'scroll',
}));

export default EmailFooter;
